import { CustomAttribute } from "../../models/customAttribute";

/**
 * Get colors and logo placement of order item
 */
const TEXT_CONST_PARAMETERS = ['Text Color', 'Text Font']

export function getVisibleAttributes(customAttributes: CustomAttribute[]) {
  return customAttributes.filter(({ key }) => !key.match(/^_/) && !TEXT_CONST_PARAMETERS.includes(key));
}

export function getTextAttributes(customAttributes: CustomAttribute[]) {
  return customAttributes.filter(({ key }) => TEXT_CONST_PARAMETERS.includes(key));
}

export function getImageAttributes(customAttributes: CustomAttribute[]) {
  // all images are hosted on /images/ url
  return customAttributes.filter(({ key, value }) => key.startsWith('_') && /https?:\/\/.*image/.test(value));
}

export function getPlayersList(customAttributes: CustomAttribute[]) {
  return customAttributes.find(({ key }) => key.includes('_Players List'));
}

export function getCategoryName(customAttributes: CustomAttribute[]) {
  const categoryValue = customAttributes.find(({ key }) =>
    key.includes('_Category'),
  )?.value;
  if (!categoryValue) return null;
  const name = categoryValue.split('/')[0];
  return name.replace(/pear/gi, '').trim();
}

export function getPatternLetter(customAttributes: CustomAttribute[], title: string) {
  const categoryValue = customAttributes.find(({ key }) =>
    key.includes('_Category'),
  )?.value;
  return getLetter(title) || getLetter(categoryValue);
}

export function getLetter(text: string) {
  const matches = /pattern\s(\w+|\d+)/gi.exec(text || '');
  if (!matches || matches.length === 0) return null;
  return matches[1];
}

export function getCutHeight(title: string) {
  const matches = /\d+\sinch/gi.exec(title);
  return matches && matches.length ? matches[0] : null;
}

export function parseColorValue(value: string) {
  const matches = /(?:Color: |^)((?:\w|\s)+)\s\((#[0-9a-fA-F]{6})/gi.exec(value);
  if (!matches) return null;
  return {
    name: matches[1],
    hex: matches[2]
  };
}

export function parseFontName(value: string) {
  const matches = /Font: ((?:\w|\s)+)/gi.exec(value);
  if (!matches) return null;
  return matches[1];
}

export function parseStrokeWidth(value: string) {
  const matches = /Width: (\d+(?:\.\d+)?)/gi.exec(value);
  if (!matches) return null;
  return matches[1];
}